import { useEffect } from 'react'
import { useAppDispatch } from 'hooks/reduxHooks'
import useOffers from 'hooks/Offers/useOffers'
import { addFlashCruiseFacets } from 'actions/CruiseActions'
import useOfferList from 'hooks/Offers/useOfferList'
import { CRUISE_FLASH_OFFERS_FILTERS } from 'constants/cruise'

function useCruiseFlashOfferFacets(): void {
  const dispatch = useAppDispatch()
  const offerList = useOfferList(CRUISE_FLASH_OFFERS_FILTERS)
  const [offers] = useOffers<App.Offer>(offerList.offerIds || [])

  // Load flash offer facets
  useEffect(() => {
    const startLocations = [...new Set(offers.map(({ startLocation }) => startLocation))].filter(Boolean)
    const endLocations = [...new Set(offers.map(({ endLocation }) => endLocation))].filter(Boolean)

    // Add start and end location to cruiseLine facets, the location appears in the destination and departure select
    dispatch(addFlashCruiseFacets(
      { facetTypes: ['departure_ports'] },
      startLocations.map((location) => ({
        name: location,
        value: location,
        category: 'departure_ports',
        flashOfferCount: 1,
      })) as App.CruiseSearchFacet[],
    ))

    dispatch(addFlashCruiseFacets(
      { facetTypes: ['destination_ports'] },
      endLocations.map((location) => ({
        name: location,
        value: location,
        category: 'destination_ports',
        flashOfferCount: 1,
      })) as App.CruiseSearchFacet[],
    ))

    const cruiseLines = offers
      .filter((offer) => (
        offer.packages[0]?.tour?.logoImageId &&
        offer.vendorName &&
        // When there is more than one vendorName e.g. Riverside/Silversea,
        // we don't want to add its logo to the filters
        !offer.vendorName.includes('/')
      ))
      .map((offer) => {
        const imageId = offer.packages[0]?.tour?.logoImageId
        const name = (offer.vendorName || imageId) as string
        return {
          name,
          originalName: name,
          value: name,
          imageId,
          category: 'cruise_lines',
          flashOfferCount: 1,
        }
      })

    dispatch(addFlashCruiseFacets(
      { facetTypes: ['cruise_lines'] },
      cruiseLines,
    ))
  }, [offers, dispatch])
}

export default useCruiseFlashOfferFacets
